import type { InformExhibitInfoPageModelState } from './types';

export const initialState: InformExhibitInfoPageModelState = {
  pageLoading: true,

  node_ID: -1,
  node_Name: '',
  node_RuleInfo: null,

  exhibit_ID: '',
  exhibit_Name: '',
  exhibit_Identity: 'exhibit',
  exhibit_ResourceType: '',
  exhibit_OnlineSwitchObj: null,
  exhibit_Info: null,

  graphShow: true,

  side_Exhibit_Cover: '',
  side_Exhibit_Title: '',
  side_Exhibit_InputTitle: null,
  side_Exhibit_Tags: [],
  side_Exhibit_AllVersions: [],
  side_Exhibit_Version: '',
  side_Exhibit_OnlyReadAttrs: [],
  side_Exhibit_OnlyEditAttrs: [],
  side_Exhibit_EditDeleteAttrs: [],
  side_CustomOptionsDrawer_Visible: false,
  side_CustomOptionDrawer_Visible: false,
  side_CustomOptionDrawer_DataSource: null,

  side_Resource_Relation: null,
};
